module.exports = __webpack_public_path__ + "static/img/banner3.1821809b.svg";